module.exports = __webpack_public_path__ + "img/chips100000.4bd9fcfc.png";